import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=e938d1ba&scoped=true"
import script from "./tabbar.vue?vue&type=script&lang=js"
export * from "./tabbar.vue?vue&type=script&lang=js"
import style0 from "./tabbar.vue?vue&type=style&index=0&id=e938d1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e938d1ba",
  null
  
)

export default component.exports